import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=293aa4fe&scoped=true&"
import script from "./loader.vue?vue&type=script&lang=js&"
export * from "./loader.vue?vue&type=script&lang=js&"
import style0 from "./loader.vue?vue&type=style&index=0&id=293aa4fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293aa4fe",
  null
  
)

export default component.exports